export default __webpack_public_path__ + "static/media/GANESHA INDISCHES RESTAURANT HOME.85035b4c.jpg";